import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
  navigation: {},
}

const reducers = {
  fetchingNavigation: (state, { payload }) => {
    const { navigationStateKey } = payload
    state.navigation[navigationStateKey] = {
      ...state.navigation[navigationStateKey],
      isFetching: true,
      error: null,
    }
  },

  fetchNavigationError: (state, { payload }) => {
    const { navigationStateKey, error } = payload
    state.navigation[navigationStateKey] = {
      ...state.navigation[navigationStateKey],
      isFetching: false,
      error,
    }
  },

  fetchNavigationSuccess: (state, { payload }) => {
    const { navigationStateKey, data } = payload
    state.navigation[navigationStateKey] = {
      data,
      isFetching: false,
      error: null,
    }
  },
}

const slice = createSlice({
  initialState,
  name: 'curriculumNavigation',
  reducers,
})

export const actions = slice.actions
export default slice.reducer
